export const config = {
  apiUrl:'https://vgkasa.island-ukraine.com/api/',
  printUrl:'https://vgkasa.island-ukraine.com/printforms/',
  intervalDataUpdate: 5000,
  scanCodeMin: 1,
  scanCodeMax: 1000,
  debugScan: true,
  enableArmDisplay2: true
};
